<template>
  <div>
    <Tabs>
      <template #tab-selector>
        <button
          :class="{ active: tabContent === TAB_AVAILABLE_FILES }"
          class="tab-link"
          @click="setTab(TAB_AVAILABLE_FILES)"
        >
          {{ $t('components.tachographFiles.tabs.availableFiles') }}
        </button>
        <button
          :class="{ active: tabContent === TAB_TASKS }"
          class="tab-link"
          @click="setTab(TAB_TASKS)"
        >
          {{ $t('components.tachographFiles.tabs.tasks') }}
        </button>
        <button
          :class="{ active: tabContent === TAB_REMINDERS }"
          class="tab-link"
          @click="setTab(TAB_REMINDERS)"
        >
          {{ $t('components.tachographFiles.tabs.reminders') }}
        </button>
      </template>
      <template #tab-content>
        <div v-show="tabContent === TAB_AVAILABLE_FILES">
          <DxDataGrid
            :ref="tachographFilesGridRef"
            :allow-column-reordering="true"
            :allow-column-resizing="true"
            :column-auto-width="true"
            :column-hiding-enabled="true"
            :data-source="availableFilesStore"
            :hover-state-enabled="true"
            :remote-operations="remoteOperations"
            :row-alternation-enabled="true"
            :show-borders="true"
            :show-column-lines="true"
            :show-row-lines="false"
          >
            <DxHeaderFilter :visible="true" />
            <DxFilterRow :visible="true" />
            <DxColumnFixing :enabled="false" />
            <DxPaging
              :page-index="0"
              :page-size="20"
            />
            <DxPager
              :show-info="true"
              :show-navigation-buttons="true"
              :visible="true"
              :info-text="$t('components.devexpress.pagerPage')
                + '{0}' + $t('components.devexpress.pagerOf')
                + '{1}'"
            />
            <DxSearchPanel
              :visible="true"
              :width="240"
              :placeholder="$t('components.tachographFiles.dataGrids.search')"
            />
            <DxColumn
              :allow-filtering="true"
              :allow-header-filtering="false"
              :caption="$t('components.tachographFiles.dataGrids.source')"
              :filter-operations="allowedOperations"
              data-field="source"
            />
            <DxColumn
              :allow-filtering="true"
              :allow-header-filtering="false"
              :caption="$t('components.tachographFiles.dataGrids.fileType')"
              :filter-operations="allowedOperations"
              data-field="type"
            />
            <DxColumn
              :allow-filtering="true"
              :allow-header-filtering="false"
              :caption="$t('components.tachographFiles.dataGrids.imei')"
              :filter-operations="allowedOperations"
              data-field="imei"
            />
            <DxColumn
              :allow-filtering="true"
              :allow-header-filtering="false"
              :caption="$t('components.tachographFiles.dataGrids.date')"
              :filter-operations="allowedOperations"
              data-field="updated_at"
            />
            <DxColumn
              :allow-filtering="true"
              :allow-header-filtering="false"
              :caption="$t('components.tachographFiles.dataGrids.fileSize')"
              :filter-operations="allowedOperations"
              data-field="file_size"
            />
            <DxColumn
              :caption="$t('components.tachographFiles.dataGrids.download')"
              cell-template="download-cell-template"
              :allow-search="false"
            />
            <template #download-cell-template="{ data }">
              <a :href="'//' + getInstance() + '/downloads/tacho_files/' + data.data.filename">
                <font-awesome-icon icon="fa-solid fa-download" />
              </a>
            </template>
          </DxDataGrid>
        </div>
        <div v-show="tabContent === TAB_TASKS">
          <div
            role="alert"
            class="alert alert-warning"
          >
            <p v-html="$t('components.tachographFiles.downloadAlert.p1')" />
            <p
              class="in-alert"
              v-html="$t('components.tachographFiles.downloadAlert.p2')"
            />
            <p
              class="in-alert"
              v-html="$t('components.tachographFiles.downloadAlert.p3')"
            />
            <p class="in-alert">
              <a
                :href="url + '/downloads/tachoapp-latest.jar'"
                class="btn btn-info btn-sm"
                target="_blank"
              >
                <i class="fa fa-download" />
                {{ $t('components.tachographFiles.downloadAlert.button') }}
              </a>
            </p>
          </div>
          <div
            class="form-horizontal form-sent-geo tacho-files-form"
            role="form"
          >
            <div class="form-body">
              <div class="form-group">
                <div class="row">
                  <div class="col-md-12 d-flex flex-row gap-2">
                    <vue-select
                      v-model="v.source.$model"
                      :options="tachoSources"
                      class="flex-grow"
                      icon="bi bi-truck"
                      :class="{ 'custom-error': v.source.$error, 'is-invalid': v.source.$error }"
                      style="flex-basis: 50%;"
                      label="label"
                      @updateSelect="emit"
                    />
                    <date-picker
                      v-model="v.dateFrom.$model"
                      v-if="source !== null && source.type === 'transmitter'"
                      :class="{ 'custom-error': v.dateFrom.$error, 'is-invalid': v.dateFrom.$error }"
                      style="flex-basis: 50%;"
                      @emitDate="emitDate"
                      :default-date="[dateFrom, dateTo]"
                    />
                  </div>
                  <div class="errors">
                    <p
                      v-if="v.dateFrom.$error || v.source.$error"
                      class="error-msg"
                    >
                      {{ $t('customValidators.allMustBeCompleted') }}
                    </p>
                  </div>
                </div>
                <button
                  class="btn btn-info btn-sm mt-3 w-100 w-md-25"
                  @click="addTachoJob"
                >
                  <i class="fa fa-download" />
                  {{ $t('components.tachographFiles.dataGrids.addTachoJob') }}
                </button>

                <div
                  class="checkboxes"
                  v-if="source !== null && source.type === 'transmitter'"
                >
                  <input
                    type="checkbox"
                    id="events"
                    v-model="events"
                  >
                  <label for="events">{{ $t('components.tachographFiles.events') }}</label>

                  <input
                    type="checkbox"
                    id="technicalData"
                    v-model="technicalData"
                  >
                  <label for="technicalData">{{ $t('components.tachographFiles.technicalData') }}</label>
                </div>
              </div>
            </div>
          </div>
          <br>
          <DxDataGrid
            :ref="tachoTasksGridRef"
            :allow-column-reordering="true"
            :allow-column-resizing="true"
            :column-auto-width="true"
            :column-hiding-enabled="true"
            :data-source="tachoTasksStore"
            :hover-state-enabled="true"
            :remote-operations="remoteOperations"
            :row-alternation-enabled="true"
            :show-borders="true"
            :show-column-lines="true"
            :show-row-lines="false"
          >
            <DxHeaderFilter :visible="true" />
            <DxFilterRow :visible="true" />
            <DxColumnFixing :enabled="false" />
            <DxPaging
              :page-index="0"
              :page-size="20"
            />
            <DxPager
              :show-info="true"
              :show-navigation-buttons="true"
              :visible="true"
              :info-text="$t('components.devexpress.pagerPage')
                + '{0}' + $t('components.devexpress.pagerOf')
                + '{1}'"
            />
            <DxSearchPanel
              :visible="true"
              :width="240"
              :placeholder="$t('components.tachographFiles.dataGrids.search')"
            />
            <DxColumn
              :allow-filtering="true"
              :allow-header-filtering="false"
              caption="#"
              width="50"
              :filter-operations="allowedOperations"
              data-field="id"
            />
            <DxColumn
              :allow-filtering="true"
              :allow-header-filtering="true"
              :caption="$t('components.tachographFiles.dataGrids.source')"
              :filter-operations="allowedOperations"
              data-field="source"
            />
            <DxColumn
              :allow-filtering="true"
              :allow-header-filtering="false"
              :caption="$t('components.tachographFiles.dataGrids.imei')"
              :filter-operations="allowedOperations"
              data-field="imei"
            />
            <DxColumn
              :allow-filtering="true"
              :allow-header-filtering="false"
              :caption="$t('components.tachographFiles.dataGrids.fileType')"
              data-field="type"
            />
            <DxColumn
              :allow-filtering="true"
              :allow-header-filtering="false"
              :caption="$t('components.tachographFiles.dataGrids.status')"
              data-field="status"
            />
            <DxColumn
              :allow-filtering="true"
              :allow-header-filtering="false"
              :caption="$t('components.tachographFiles.dataGrids.attempt')"
              data-field="attempt"
              cell-template="attempt-cell-template"
            />
            <DxColumn
              :caption="$t('components.tachographFiles.dataGrids.options')"
              cell-template="options-cell-template"
              :allow-search="false"
            />
            <template #options-cell-template="{ data }">
              <div style="display: flex;">
                <a
                  @click="resetTachoJob(data.data.id)"
                  style="font-size: 16px; margin: 0 10px 0 0;"
                >
                  <font-awesome-icon
                    icon="fa-solid fa-reply-all"
                  />
                  {{ $t('components.tachographFiles.dataGrids.resetTachoJob') }}
                </a>
                <br>
                <a
                  @click="removeTachoJob(data.data.id)"
                  style="font-size: 16px;"
                >
                  <font-awesome-icon
                    icon="fa-solid fa-trash"
                  />
                  {{ $t('components.tachographFiles.dataGrids.deleteTachoJob') }}
                </a>
              </div>
            </template>
            <template #attempt-cell-template="{ data }">
              {{ data.data.attempt }} / 3
            </template>
          </DxDataGrid>
        </div>
        <div v-show="tabContent === TAB_REMINDERS">
          <div class="action-buttons">
            <a
              class="btn btn-success"
              data-bs-toggle="tooltip"
              data-bs-placement="bottom"
              :title="$t('components.tachographFiles.massBtn1Additional')"
              @click="postAllDriversTachoJobs"
            >
              <font-awesome-icon icon="fa-solid fa-id-card" />&nbsp;
              {{ $t('components.tachographFiles.massBtn1') }}
            </a>
            <a
              class="btn btn-success"
              data-bs-toggle="tooltip"
              data-bs-placement="bottom"
              :title="$t('components.tachographFiles.massBtn2Additional')"
              @click="postAllVehiclesTachoJobs"
            >
              <font-awesome-icon icon="fa-solid fa-tachograph-digital" />&nbsp;
              {{ $t('components.tachographFiles.massBtn2') }}
            </a>
            <a
              class="btn btn-success"
              data-bs-toggle="tooltip"
              data-bs-placement="bottom"
              :title="$t('components.tachographFiles.massBtn3Additional')"
              @click="postAllExpiredTachoJobs"
            >
              <font-awesome-icon icon="fa-solid fa-hourglass-end" />&nbsp;
              {{ $t('components.tachographFiles.massBtn3') }}
            </a>
          </div>
          <DxDataGrid
            :ref="remindersDriversGridRef"
            :allow-column-reordering="true"
            :allow-column-resizing="true"
            :column-auto-width="true"
            :column-hiding-enabled="true"
            :data-source="remindersDriversStore"
            :hover-state-enabled="true"
            :remote-operations="remoteOperations"
            :row-alternation-enabled="true"
            :show-borders="true"
            :show-column-lines="true"
            :show-row-lines="false"
          >
            <DxFilterRow :visible="true" />
            <DxColumnFixing :enabled="false" />
            <DxPaging
              :page-index="0"
              :page-size="20"
            />
            <DxPager
              :show-info="true"
              :show-navigation-buttons="true"
              :visible="true"
              :info-text="$t('components.devexpress.pagerPage')
                + '{0}' + $t('components.devexpress.pagerOf')
                + '{1}'"
            />
            <DxColumn
              :allow-filtering="true"
              :allow-header-filtering="true"
              :caption="$t('components.tachographFiles.dataGrids.driver')"
              :filter-operations="allowedOperations"
              data-field="name"
              width="200"
              cell-template="driver-cell-template"
            />
            <DxColumn
              :allow-filtering="true"
              :allow-header-filtering="false"
              :caption="$t('components.tachographFiles.dataGrids.lastDownload')"
              :filter-operations="allowedOperations"
              data-field="last_download"
              cell-template="last-download-cell-template"
            />
            <DxColumn
              :allow-filtering="true"
              :allow-header-filtering="false"
              :caption="$t('components.tachographFiles.dataGrids.nextDownload')"
              :filter-operations="allowedOperations"
              data-field="next_download"
              cell-template="next-download-cell-template"
            />
            <DxColumn
              :allow-filtering="true"
              :allow-header-filtering="false"
              :caption="$t('components.tachographFiles.dataGrids.remaining')"
              :filter-operations="allowedOperations"
              data-field="days_left"
              cell-template="remaining-cell-template"
            />
            <DxColumn
              :caption="$t('components.tachographFiles.dataGrids.options')"
              cell-template="options-cell-template"
              :allow-search="false"
            />
            <template #options-cell-template="{ data }">
              <a
                @click="addDriverTachoJob(data.data)"
                v-if="!data.data.has_planned_job && data.data.card !== null && data.data.card_validity >= moment().format('YYYY-MM-DD')"
                style="color: #1E90FF;"
              >
                <font-awesome-icon icon="fa-solid fa-download" />
                {{ $t('components.tachographFiles.dataGrids.addTachoJob') }}
                <p v-if="data.data.last_download === null">
                  <i
                    class="fa fa-exclamation-triangle"
                    style="color: red !important;"
                  /> <i
                    style="color: red !important;"
                  >
                    {{ $t('components.tachographFiles.dataGrids.neverDownloaded') }}</i>
                </p>
              </a>
              <span v-if="data.data.has_planned_job"><i>{{
                $t('components.tachographFiles.dataGrids.taskInProgress')
              }}</i>
              </span>
              <span v-if="data.data.card === null"><i
                class="fa fa-exclamation-triangle"
              /> <i>{{
                $t('components.tachographFiles.dataGrids.noDriverCardAssigned')
              }}</i>
              </span>
              <span
                v-if="data.data.card_validity < moment().format('YYYY-MM-DD') || data.data.card_validity === null"
              ><i
                class="fa fa-exclamation-triangle"
              /> <i>{{
                $t('components.tachographFiles.dataGrids.validityDateExpired')
              }}</i>
              </span>
            </template>
            <template #driver-cell-template="{ data }">
              <p>{{ data.data.name }}</p>
              <small>{{ $t('components.tachographFiles.dataGrids.card') }}: {{ data.data.card ?? '---' }}</small>
            </template>
            <template #last-download-cell-template="{ data }">
              <p v-if="data.data.last_download">
                {{ data.data.last_download }}
              </p>
              <p
                v-else
                style="color: red;"
              >
                ---
              </p>
            </template>
            <template #next-download-cell-template="{ data }">
              <p v-if="data.data.next_download">
                {{ data.data.next_download }}
              </p>
              <p
                v-else
                style="color: red;"
              >
                ---
              </p>
            </template>
            <template #remaining-cell-template="{ data }">
              <p
                v-if="data.data.days_left"
                :style="{
                  color: data.data.days_left > 7 ? 'green' :
                    data.data.days_left >= 1 ? 'yellow' :
                    'red'
                }"
              >
                {{ data.data.days_left }} {{ $t('components.tachographFiles.dataGrids.days') }}
              </p>
              <p
                v-else
                style="color: red;"
              >
                ---
              </p>
            </template>
          </DxDataGrid>

          <DxDataGrid
            :ref="remindersVehiclesGridRef"
            :allow-column-reordering="true"
            :allow-column-resizing="true"
            :column-auto-width="true"
            :column-hiding-enabled="true"
            :data-source="remindersVehiclesStore"
            :hover-state-enabled="true"
            :remote-operations="remoteOperations"
            :row-alternation-enabled="true"
            :show-borders="true"
            :show-column-lines="true"
            :show-row-lines="false"
          >
            <DxFilterRow :visible="true" />
            <DxColumnFixing :enabled="false" />
            <DxPaging
              :page-index="0"
              :page-size="20"
            />
            <DxPager
              :show-info="true"
              :show-navigation-buttons="true"
              :visible="true"
              :info-text="$t('components.devexpress.pagerPage')
                + '{0}' + $t('components.devexpress.pagerOf')
                + '{1}'"
            />
            <DxColumn
              :allow-filtering="true"
              :allow-header-filtering="true"
              :caption="$t('components.tachographFiles.dataGrids.vehicle')"
              :filter-operations="allowedOperations"
              data-field="number_plate"
              width="200"
              cell-template="vehicle-cell-template"
            />
            <DxColumn
              :allow-filtering="true"
              :allow-header-filtering="false"
              :caption="$t('components.tachographFiles.dataGrids.lastDownload')"
              :filter-operations="allowedOperations"
              data-field="last_download"
              cell-template="last-download-cell-template"
            />
            <DxColumn
              :allow-filtering="true"
              :allow-header-filtering="false"
              :caption="$t('components.tachographFiles.dataGrids.nextDownload')"
              :filter-operations="allowedOperations"
              data-field="next_download"
              cell-template="next-download-cell-template"
            />
            <DxColumn
              :allow-filtering="true"
              :allow-header-filtering="false"
              :caption="$t('components.tachographFiles.dataGrids.remaining')"
              :filter-operations="allowedOperations"
              data-field="days_left"
              cell-template="remaining-cell-template"
            />
            <DxColumn
              :caption="$t('components.tachographFiles.dataGrids.options')"
              cell-template="options-cell-template"
              :allow-search="false"
            />
            <template #options-cell-template="{ data }">
              <a
                @click="addVehicleTachoJob(data.data)"
                style="color: #1E90FF;"
                v-if="!data.data.has_planned_job"
              >
                <font-awesome-icon icon="fa-solid fa-download" />
                {{ $t('components.tachographFiles.dataGrids.addTachoJob') }}
                <p v-if="data.data.last_download === null">
                  <i
                    class="fa fa-exclamation-triangle"
                    style="color: red !important;"
                  /> <i
                    style="color: red !important;"
                  >
                    {{ $t('components.tachographFiles.dataGrids.neverDownloaded') }}</i>
                </p>
              </a>
              <span v-else-if="data.data.has_planned_job">
                <i>{{ $t('components.tachographFiles.dataGrids.taskInProgress') }}</i>
              </span>
            </template>
            <template #vehicle-cell-template="{ data }">
              <p>{{ data.data.number_plate }}</p>
              <small>{{ $t('components.tachographFiles.dataGrids.imei') }}: {{ data.data.imei }}</small>
            </template>
            <template #last-download-cell-template="{ data }">
              <p v-if="data.data.last_download">
                {{ data.data.last_download }}
              </p>
              <p
                v-else
                style="color: red;"
              >
                ---
              </p>
            </template>
            <template #next-download-cell-template="{ data }">
              <p v-if="data.data.next_download">
                {{ data.data.next_download }}
              </p>
              <p
                v-else
                style="color: red;"
              >
                ---
              </p>
            </template>
            <template #remaining-cell-template="{ data }">
              <p
                v-if="data.data.days_left"
                :style="{
                  color: data.data.days_left > 7 ? 'green' :
                    data.data.days_left >= 1 ? 'yellow' :
                    'red'
                }"
              >
                {{ data.data.days_left }} {{ $t('components.tachographFiles.dataGrids.days') }}
              </p>
              <p
                v-else
                style="color: red;"
              >
                ---
              </p>
            </template>
          </DxDataGrid>
        </div>
      </template>
    </Tabs>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import Tabs from '@/components/extras/Tabs.vue'
import useVuelidate from '@vuelidate/core'
import constants from '@/utils/constants'
import {
  DxColumn,
  DxColumnFixing,
  DxDataGrid,
  DxFilterRow,
  DxHeaderFilter,
  DxPager,
  DxPaging,
  DxSearchPanel
} from 'devextreme-vue/data-grid'
import VueSelect from '@/components/extras/VueSelect.vue'
import CustomStore from 'devextreme/data/custom_store'
import { getStore as doneStore } from '@/stores/tachoDoneListStore'
import { getStore as tachoJobStore } from '@/stores/tachoJobsListStore'
import { getStore as tachoRemindersDrivers } from '@/stores/tachoRemindersDriversStore'
import { getStore as tachoRemindersVehicles } from '@/stores/tachoRemindersVehiclesStore'
import { getTachoSources } from '@/crud/getters'
import { useI18n } from 'vue-i18n'
import {
  postAllDriversTachoJobs,
  postAllExpiredTachoJobs,
  postAllVehiclesTachoJobs,
  postTachoJob
} from '@/crud/senders'
import { datePrettier } from '@/utils/tools'
import { required, requiredIf } from '@/vuelidate/i18n-validators'
import DatePicker from '@/components/extras/DatePicker.vue'
import { removeTachoJob } from '@/crud/removers'
import { resetTachoJob } from '@/crud/reseters'
import { getInstance } from '@/http-common'
import moment from 'moment'
import { Tooltip } from 'bootstrap'

/**
 * Tabs
 */
const TAB_AVAILABLE_FILES = 0
const TAB_TASKS = 1
const TAB_REMINDERS = 2

export default defineComponent({
  name: 'TachographFiles',
  components: {
    DatePicker,
    Tabs,
    DxColumn,
    DxColumnFixing,
    DxDataGrid,
    DxHeaderFilter,
    DxPager,
    DxPaging,
    DxSearchPanel,
    DxFilterRow,
    VueSelect
  },
  setup() {
    const { t } = useI18n()

    return {
      v: useVuelidate(),
      t
    }
  },
  data(): {
    TAB_AVAILABLE_FILES: number,
    TAB_TASKS: number,
    TAB_REMINDERS: number,
    tabContent: number,
    constants: any,
    availableFilesStore: CustomStore,
    remindersDriversStore: CustomStore,
    remindersVehiclesStore: CustomStore,
    tachoTasksStore: CustomStore,
    tachoSources: Array<any>,
    allowedOperations: Array<string>,
    remoteOperations: boolean,
    tachographFilesGridRef: string,
    remindersDriversGridRef: string,
    remindersVehiclesGridRef: string,
    tachoTasksGridRef: string,
    source: any,
    dateFrom: any,
    dateTo: string,
    url: string,
    events: boolean,
    technicalData: boolean
  } {
    return {
      TAB_AVAILABLE_FILES: TAB_AVAILABLE_FILES,
      TAB_TASKS: TAB_TASKS,
      TAB_REMINDERS: TAB_REMINDERS,
      tabContent: 1,
      constants: constants,
      availableFilesStore: doneStore(),
      remindersDriversStore: tachoRemindersDrivers(),
      remindersVehiclesStore: tachoRemindersVehicles(),
      tachoTasksStore: tachoJobStore(),
      tachoSources: [],
      allowedOperations: ['contains', '=', 'notcontains', '!='],
      remoteOperations: true,
      tachographFilesGridRef: 'tachographFilesGrid',
      remindersDriversGridRef: 'remindersDriversGrid',
      remindersVehiclesGridRef: 'remindersVehiclesGrid',
      tachoTasksGridRef: 'tachoTasksGrid',
      source: null,
      dateFrom: moment().subtract(90, 'days').format('YYYY-MM-DD HH:mm'),
      dateTo: moment().format('YYYY-MM-DD HH:mm'),
      url: process.env.VUE_APP_BASE_URL,
      events: false,
      technicalData: false
    }
  },
  computed: {
    tachographFilesGrid() {
      const self: any = this;
      return self.tachographFilesGridRef && self.$refs[self.tachographFilesGridRef]
          ? self.$refs[self.tachographFilesGridRef].instance
          : null;
    },
    remindersDriversGrid() {
      const self: any = this;
      return self.remindersDriversGridRef && self.$refs[self.remindersDriversGridRef]
          ? self.$refs[self.remindersDriversGridRef].instance
          : null;
    },
    remindersVehiclesGrid() {
      const self: any = this;
      return self.remindersVehiclesGridRef && self.$refs[self.remindersVehiclesGridRef]
          ? self.$refs[self.remindersVehiclesGridRef].instance
          : null;
    },
    tachoTasksGrid() {
      const self: any = this;
      return self.tachoTasksGridRef && self.$refs[self.tachoTasksGridRef]
          ? self.$refs[self.tachoTasksGridRef].instance
          : null;
    }
  },
  methods: {
    moment: moment,
    getInstance: getInstance,
    setTab(tab: number): void {
      this.tabContent = tab
    },
    addTachoJob(): void {
      const self: any = this
      if (this.source) {
        const dataForm: any = {}
        dataForm.attempt = 1
        if (self.source.type == 'driver')
          dataForm.card = self.source.value
        else
          dataForm.imei = self.source.value
        dataForm.source = self.source.source
        dataForm.type = self.source.type == 'driver' ? '2' : '1'

        if (dataForm.type == 1) { // plik tacho
          dataForm.start = self.dateFrom
          dataForm.end = self.dateTo

          dataForm.type = parseInt(dataForm.type)
          if (this.events)
            dataForm.type += 8
          if (this.technicalData)
            dataForm.type += 32
        } else {
          dataForm.start = moment().subtract(28, 'days').format('YYYY-MM-DD HH:mm')
          dataForm.end = moment().format('YYYY-MM-DD HH:mm')
        }

        postTachoJob(dataForm).then(() => {
          this.$toast.success(this.t('components.tachographFiles.addedSuccessfully'))
          this.tachoTasksGrid.refresh()
        }).catch((err) => {
          if (err.response.data.message === 'NO_DEVICE')
            this.$toast.error(this.t('components.tachographFiles.noDevice'))
          else if (err.response.data.message === 'DIFFERENT_CARD_IN_DEVICE')
            this.$toast.error(this.t('components.tachographFiles.differentCardInDevice'))
          else
            this.$toast.error(this.t('components.tachographFiles.error'))
          this.tachoTasksGrid.refresh()
        })
      }
    },
    postAllDriversTachoJobs(): void {
      postAllDriversTachoJobs().then(() => {
        this.$toast.success(this.t('components.tachographFiles.addedSuccessfully'))
        this.tachoTasksGrid.refresh()
      })
    },
    postAllVehiclesTachoJobs(): void {
      postAllVehiclesTachoJobs().then(() => {
        this.$toast.success(this.t('components.tachographFiles.addedSuccessfully'))
        this.tachoTasksGrid.refresh()
      })
    },
    postAllExpiredTachoJobs(): void {
      postAllExpiredTachoJobs().then(() => {
        this.$toast.success(this.t('components.tachographFiles.addedSuccessfully'))
        this.tachoTasksGrid.refresh()
      })
    },
    removeTachoJob(id: number) {
      removeTachoJob(id)
          .then(() => {
            this.$toast.success(this.t('components.tachographFiles.deletedSuccessfully'))
            this.tachoTasksGrid.refresh()
          })
          .catch(() => {
            this.$toast.error(this.t('components.tachographFiles.error'))
            this.tachoTasksGrid.refresh()
          })
    },
    resetTachoJob(id: number) {
      resetTachoJob(id)
          .then(() => {
            this.$toast.success(this.t('components.tachographFiles.resetedSuccessfully'))
            this.tachoTasksGrid.refresh()
          })
          .catch(() => {
            this.$toast.error(this.t('components.tachographFiles.jobInProgress'))
            this.tachoTasksGrid.refresh()
          })
    },
    emit(value): void {
      if (value)
        this.source = { 'type': value.source, 'value': value.value, 'source': value.description }
      else
        this.source = null
    },
    datePrettier: datePrettier,
    emitDate(value): void {
      if (value) {
        this.dateFrom = this.datePrettier(new Date(value[0]))
        this.dateTo = this.datePrettier(new Date(value[1]))
      } else {
        this.dateFrom = ''
        this.dateTo = ''
      }
    },
    addDriverTachoJob(data) {
      const dataForm: object = {
        attempt: 1,
        card: data.card,
        type: 2,
        start: moment().subtract(28, 'days').format('YYYY-MM-DD HH:mm'),
        end: moment().format('YYYY-MM-DD HH:mm')
      }

      postTachoJob(dataForm).then(() => {
        this.$toast.success(this.t('components.tachographFiles.addedSuccessfully'))
        this.tachoTasksGrid.refresh()
      }).catch((err) => {
        if (err.response.data.message === 'NO_DEVICE')
          this.$toast.error(this.t('components.tachographFiles.noDevice'))
        else if (err.response.data.message === 'DIFFERENT_CARD_IN_DEVICE')
          this.$toast.error(this.t('components.tachographFiles.differentCardInDevice'))
        else
          this.$toast.error(this.t('components.tachographFiles.error'))
        this.tachoTasksGrid.refresh()
      })
    },
    addVehicleTachoJob(data) {
      const dataForm: object = {
        attempt: 1,
        imei: data.imei,
        source: data.number_plate,
        type: 1,
        start: this.dateFrom,
        end: this.dateTo
      }

      postTachoJob(dataForm).then(() => {
        this.$toast.success(this.t('components.tachographFiles.addedSuccessfully'))
        this.tachoTasksGrid.refresh()
      }).catch((err) => {
        if (err.response.data.message === 'NO_DEVICE')
          this.$toast.error(this.t('components.tachographFiles.noDevice'))
        else if (err.response.data.message === 'DIFFERENT_CARD_IN_DEVICE')
          this.$toast.error(this.t('components.tachographFiles.differentCardInDevice'))
        else
          this.$toast.error(this.t('components.tachographFiles.error'))
        this.tachoTasksGrid.refresh()
      })
    }
  },
  mounted() {
    const self = this

    /**
     * Initialize bootstrap tooltip
     */
    const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new Tooltip(tooltipTriggerEl)
    })
    getTachoSources()
        .then((response: any) => {
          while (this.tachoSources.length > 0) {
            this.tachoSources.pop()
          }
          if (Array.isArray(response.data)) {
            response.data.forEach(function (obj) {
            if (obj.source == 'driver')
              obj.label = '(' + self.t('components.tachographFiles.dataGrids.selectDriverCard') + ') ' + obj.description

            if (obj.source == 'transmitter')
              obj.label = '(' + self.t('components.tachographFiles.dataGrids.vehicle') + ') ' + obj.description

            self.tachoSources.push(obj)
          })
          }
        })

    setInterval(() => {
      if (this.tabContent === TAB_TASKS && this.tachoTasksGrid) {
        this.tachoTasksGrid.refresh();
      }

      if (this.tabContent === TAB_AVAILABLE_FILES && this.tachographFilesGrid) {
        this.tachographFilesGrid.refresh();
      }

      if (this.tabContent === TAB_REMINDERS) {
        if (this.remindersDriversGrid) {
          this.remindersDriversGrid.refresh();
        }
        if (this.remindersVehiclesGrid) {
          this.remindersVehiclesGrid.refresh();
        }
      }
    }, 3000);
  },
  validations() {
    return {
      source: {
        required
      },
      dateFrom: {
        required: requiredIf(() => {
          return this.source.type === 'transmitter'
        })
      }
    }
  }
})
</script>

<style lang="scss" scoped>
div :deep(.dx-datagrid-header-panel) {
  padding: 15px 15px 5px 0 !important;
}

div :deep(.dx-overlay) {
  display: none !important;
}

div :deep(small) {
  font-weight: lighter;
  font-size: 80%;
  color: #858585;
  text-transform: uppercase;
}

div :deep(p) {
  margin-bottom: 0;
}

div :deep(.btn-info) {
  background-color: #252422;
}

:deep(div .btn-check:checked + .btn.btn-info),
:deep(.btn-check:active + .btn.btn-info),
:deep(.btn.btn-info:focus:not(.btn-active)),
:deep(.btn.btn-info:hover:not(.btn-active)),
:deep(.btn.btn-info:active:not(.btn-active)),
:deep(.btn.btn-info.active),
:deep(.btn.btn-info.show),
:deep(.show > .btn.btn-info) {
  background-color: #252422 !important;
}
div :deep(p.in-alert) {
  margin-top: 5px;
}

div :deep(.dx-loadpanel-content) {
  display: none;
}

div.checkboxes {
  display: inline-block !important;
  position: relative;
  top: 10px;
  left: 20px;
}

label {
  display: inline-block !important;
  margin: 0 10px 0 0;
  font-weight: 700;
  font-size: 13px;
}

input[type="checkbox"] {
  vertical-align: text-top;
  margin: 0 5px 0 0;
}

.action-buttons {
  margin: 0 0 15px 0;
  text-align: right;

  a {
    margin: 0 5px;
    font-size: 12px;
    padding: 6px !important;
  }
}

// Mobile responsive styles
@media (max-width: 767px) {
  .tacho-files-form .d-flex.flex-row {
    flex-direction: column !important;
  }

  .tacho-files-form .d-flex.flex-row > * {
    flex-basis: 100% !important;
    width: 100% !important;
    margin-bottom: 10px;
  }

  .tacho-files-form .d-flex.flex-row > *:last-child {
    margin-bottom: 0;
  }
}
</style>